import styled from 'styled-components';

export const AvatarNavWidgetStyled = styled.div`
  position: relative;
  .avatar_nav_container {
    display: flex;
    align-items: center;
    column-gap: 0.75rem;
    cursor: pointer;
    /* ขอบมนรอบชื่อ+avatar ให้ hover มีพื้นหลังจาง ๆ และ avatar ขยายเล็กน้อย */
    /* ระยะขอบเท่ากันทุกด้าน (avatar ไม่ชิดขอบ) */
    padding: 0.5rem 0.625rem 0.5rem 0.875rem;
    column-gap: 0.875rem;
    border-radius: 2.5rem;
    transition: background 0.2s ease, box-shadow 0.2s ease;
    /* ไม่ใช้ transform/scale กับไอคอน (ทำให้ภาพกระตุก/เบลอตอน hover) ใช้แค่วงแหวนกับพื้นหลัง */
    .nui_right_col .avatar {
      transition: box-shadow 0.2s ease;
    }
    &:hover {
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      box-shadow: 0 0.25rem 0.75rem rgb(8 21 66 / 10%);
      .nui_right_col .avatar {
        box-shadow: 0 0 0 0.1875rem ${({ theme }) => theme.COLORS.BLUE_1};
      }
    }
    .nui_left_col {
      .il_title {
        text-align: right;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      }
      .il_sub_title {
        color: ${({ theme }) => theme.COLORS.GRAY_5};
        font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      }
    }
    .nui_right_col {
    }
  }
  .avatar_nav_menu {
    /* ชิดขวาใต้ avatar ไม่ล้นออกนอกจอ และลอยเหนือเนื้อหา/แท็บด้านล่าง */
    position: absolute;
    top: calc(100% + 0.5rem);
    right: 0;
    z-index: 50;
    min-width: 10rem;
    padding: 0.5rem;
    border-radius: 0.875rem;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    border: 0.0625rem solid ${({ theme }) => theme.COLORS.GRAY_4};
    box-shadow: 0 0.5rem 1.5rem rgb(8 21 66 / 12%);
    .atn_menu_item {
      padding: 0.5rem 0.75rem;
      display: flex;
      align-items: center;
      column-gap: 0.5rem;
      border-radius: 0.5rem;
      cursor: pointer;
      transition: background 0.15s;
      span {
        color: ${({ theme }) => theme.COLORS.RED_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
      &:hover {
        background: #fff1f1;
      }
    }
  }
`;
